import { Lock } from "components/icons/generated";
import Badge from "ds/components/Badge";
import Box from "ds/components/Box";
import Icon from "ds/components/Icon";
import Typography from "ds/components/Typography";

import { InputChange } from "../../types";
import ChangeHistoryCardValueBadge from "../../ChangeHistoryCard/components/ValueBadge";

type InputChangeItemProps = {
  change: InputChange;
};

const InputChangeItem = ({ change }: InputChangeItemProps) => (
  <Typography tag="div" variant="p-body3" color="secondary">
    <Box gap="small" align="center" wrap>
      <Badge variant="gray" type="weak" text={change.fieldName} />
      {change.secret && <Icon src={Lock} noShrink color="tertiary" />}
      {change.secret ? "checksum will revert from" : "will revert from"}
      <ChangeHistoryCardValueBadge
        variant={change.currentValue === "(not set)" ? "gray" : "red"}
        text={change.currentValue}
      />
      to
      <ChangeHistoryCardValueBadge
        variant={change.previousValue === "(not set)" ? "gray" : "green"}
        text={change.previousValue}
      />
    </Box>
  </Typography>
);

export default InputChangeItem;
